import React from 'react';
import { ACTIVE_BRAND } from '../branding';
import './HomePage.css';

function HomePage({ onServiceSelect }) {
  // Use brand-specific services from branding configuration
  const services = ACTIVE_BRAND.services || [];

  return (
    <div className="home-page">
      <div className="home-content">
        <div className="services-grid">
          {services.map(service => (
            <div
              key={service.id}
              className="service-tile"
              onClick={() => onServiceSelect(service.id)}
              style={{
                borderColor: ACTIVE_BRAND.colors.primary,
              }}
            >
              {service.image ? (
                <div className="service-image">
                  <img src={service.image} alt={service.title} />
                </div>
              ) : (
                <div className="service-icon">{service.icon}</div>
              )}
              <h3 className="service-title" style={{ color: ACTIVE_BRAND.colors.primary }}>
                {service.title}
              </h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
